import { render, staticRenderFns } from "./ForumResponseAnimatedReactionButton.vue?vue&type=template&id=6f367171&scoped=true"
import script from "./ForumResponseAnimatedReactionButton.vue?vue&type=script&lang=js"
export * from "./ForumResponseAnimatedReactionButton.vue?vue&type=script&lang=js"
import style0 from "./ForumResponseAnimatedReactionButton.vue?vue&type=style&index=0&id=6f367171&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f367171",
  null
  
)

export default component.exports